import CloseIcon from '@mui/icons-material/Close';
import Carousel from 'react-material-ui-carousel'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useTreatmentOnGoing } from 'context';
import { useState } from 'react';

type IDialogDocument = {
  title: string;
  open: boolean;
  onClose: () => void;
  variant?: 'image' | 'outlined' | 'contained';
  loading?: boolean;
};

export const DialogDocument: React.FC<IDialogDocument> = ({
  title,
  open,
  onClose,
  loading,
}) => {

  const handleClose = () => {
    if (loading) {
      return;
    }
    onClose();
  };



  const { _docs } = useTreatmentOnGoing();
  return (
    <Dialog open={open} fullWidth maxWidth='lg' onClose={handleClose}>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Carousel autoPlay={false} >
          {
            _docs.map((document, i)=> { 
            return ( 
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <embed width='1000px' height='1200px' src={`data:application/pdf;base64,${document.base64}`}></embed> 
              </div>
      
              )
              }
            )   
          } 
        </Carousel>
      </DialogContent>
    </Dialog>
  );
};
